import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-10611a81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "students-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Students", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Students", -1))
const _hoisted_5 = { class: "controls-wrapper" }
const _hoisted_6 = { class: "filters" }
const _hoisted_7 = { class: "search-inputs" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "First Name", -1))
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name", -1))
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "school" }, "School", -1))
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "group" }, "Group", -1))
const _hoisted_16 = { class: "actions" }
const _hoisted_17 = { class: "students-table" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "First Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", null, "School"),
    /*#__PURE__*/_createElementVNode("th", null, "Group"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_19 = { class: "action-buttons" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "pagination" }
const _hoisted_24 = { class: "pagination-controls" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow" }, "←", -1))
const _hoisted_27 = { class: "page-info" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow" }, "→", -1))
const _hoisted_32 = { class: "items-per-page" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "itemsPerPage" }, "Items per page:", -1))
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<option value=\"10\" data-v-10611a81>10</option><option value=\"20\" data-v-10611a81>20</option><option value=\"30\" data-v-10611a81>30</option><option value=\"100\" data-v-10611a81>100</option><option value=\"all\" data-v-10611a81>All</option>", 5)
const _hoisted_39 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              id: "firstName",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.firstName) = $event)),
              placeholder: "Filter by first name"
            }, null, 512), [
              [_vModelText, _ctx.filters.firstName]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              id: "lastName",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.lastName) = $event)),
              placeholder: "Filter by last name"
            }, null, 512), [
              [_vModelText, _ctx.filters.lastName]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              id: "school",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.school) = $event)),
              placeholder: "Filter by school"
            }, null, 512), [
              [_vModelText, _ctx.filters.school]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              id: "group",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.group) = $event)),
              placeholder: "Filter by group"
            }, null, 512), [
              [_vModelText, _ctx.filters.group]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportToCSV && _ctx.exportToCSV(...args))),
          class: "secondary-button"
        }, " Export CSV "),
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args))),
          class: "secondary-button"
        }, " Export Excel "),
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addStudent && _ctx.addStudent(...args))),
          class: "primary-button"
        }, "Add Student")
      ])
    ]),
    _createElementVNode("table", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedStudents, (student) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: student.id
          }, [
            _createElementVNode("td", null, _toDisplayString(student.firstName), 1),
            _createElementVNode("td", null, _toDisplayString(student.lastName), 1),
            _createElementVNode("td", null, _toDisplayString(student.primarySchool ? student.primarySchool.name : ""), 1),
            _createElementVNode("td", null, _toDisplayString(student.group ? student.group.name : ""), 1),
            _createElementVNode("td", _hoisted_19, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.viewStudent(student.id)),
                class: "view-button"
              }, " View ", 8, _hoisted_20),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.editStudent(student.id)),
                class: "edit-button"
              }, " Edit ", 8, _hoisted_21),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.deleteStudent(student.id)),
                class: "delete-button"
              }, " Delete ", 8, _hoisted_22)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args))),
          disabled: _ctx.currentPage === 1,
          class: "pagination-button"
        }, [
          _hoisted_26,
          _createTextVNode(" Previous ")
        ], 8, _hoisted_25),
        _createElementVNode("div", _hoisted_27, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentPage) = $event)),
            class: "page-select",
            disabled: _ctx.totalPages === 1
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
              return (_openBlock(), _createElementBlock("option", {
                key: page,
                value: page
              }, _toDisplayString(page), 9, _hoisted_29))
            }), 128))
          ], 8, _hoisted_28), [
            [_vModelSelect, _ctx.currentPage]
          ]),
          _createElementVNode("span", null, "of " + _toDisplayString(_ctx.totalPages), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
          disabled: _ctx.currentPage === _ctx.totalPages,
          class: "pagination-button"
        }, [
          _createTextVNode(" Next "),
          _hoisted_31
        ], 8, _hoisted_30)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
          id: "itemsPerPage",
          class: "items-select"
        }, _hoisted_39, 512), [
          [_vModelSelect, _ctx.itemsPerPage]
        ])
      ])
    ])
  ]))
}